import { Component, OnDestroy, OnInit } from '@angular/core';
import { UserService } from 'src/app/Services/user.service';
import { WalletService } from 'src/app/Services/wallet.service';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';
import { MessagingService } from 'src/app/Services/messaging.service';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { OtcService } from 'src/app/Services/otc.service';
import { ToastrService } from 'ngx-toastr';
import { TourActiveService } from 'src/app/Services/tour-active.service';
import { ChangeSideBarTooltipLanguage } from 'src/app/Services/change-sidebar-tooltip.service';

import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { GlobalConstants } from '../global-constans';
import { zendeskChangeLanguage, zendeskHide, } from 'src/app/Services/zendesk.service';
import { CalculatorServices } from 'src/app/Services/calculator.service';
import { ObsicashStoreService } from '../../Services/obsicash/obsicash-store.service';
import { CustomUrlSerializer } from '../../shared/models/UrlSerializer/custom-url-serializer';
import { LangService } from 'src/app/Services/lang.service';

declare var $: any;
declare var SockJS: any;
declare var Stomp: any;
declare let ga: Function;

// declare let fbq: Function;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  // General data
  tokenApp = false;
  userData: any = {};
  profileData: any = {};
  unsubscribe$: Subject<void> = new Subject<void>();
  mode: any = 'day';
  message: any = '';
  menuActive: any = false;
  verificationStatusEnum: any = undefined;

  // Currency data
  currencies: any = [];
  currentCurrency: any = {};
  searchcurrency1: any = '';
  allCurrencies: any = [];
  allCurrencies1: any = [];
  usdDollar: any = {};

  // Language
  currentLang: any = '';
  languageMessage = false;
  languages: any = [];
  language = { lang: 'en', text: 'English' };

  // Notification control
  notifiations: any = [];
  approvalData: any = {};
  selectedOrder: any = {};
  loading: any = false;
  blockedMessage: any;
  selectAllNotification: boolean = false;
  activeDeleteOption: boolean = false;
  numberOfChecked: number = 0;
  notificationSelected: boolean = false;
  arrNotification: any = [];
  idSelectCheckBox: string = '';

  // Notification Socket
  stompClient: any;
  stompClientActiveUser: any;
  isClicked: boolean = true;

  // Tour and cookies
  showTour = false;
  public showCookies = true;
  public imgUrl: any = environment.imgUrl;

  constructor(
    private messagingService: MessagingService,
    public obsicashStore: ObsicashStoreService,
    public userService: UserService,
    private cookieService: CookieService,
    private otcService: OtcService,
    private walletService: WalletService,
    private translate: TranslateService,
    private toast: ToastrService,
    private route: Router,
    private tourActiveService: TourActiveService,
    private changeSideBarTooltipLanguage: ChangeSideBarTooltipLanguage,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private calculatorServices: CalculatorServices,
    private langService: LangService
  ) {
    this.mode = localStorage.getItem('MODE');
    this.userData = this.userService.getLoggedData();

    let localCurrencies: any = localStorage.getItem(
      'OBSIDIAM-LOCAL-CURRENCIES'
    );
    localCurrencies = localCurrencies ? JSON.parse(localCurrencies) : [];
    if (localCurrencies.length) {
      this.userData.preferredLanguage = this.userData.preferredLanguage || 'en';
      if (typeof this.userData.preferredCurrency === 'string') {
        const currency = localCurrencies.find(
          (a) => a.shortName === this.userData.preferredCurrency
        );
        this.userData.preferredCurrency = currency || {};
        this.languageMessage = false;
      } else if (
        this.userData.preferredCurrency &&
        !this.userData.preferredCurrency.fullName
      ) {
        const currency = localCurrencies.find(
          (a) => a.shortName === this.userData.preferredCurrency.shortName
        );
        this.userData.preferredCurrency = currency || {};
        this.languageMessage = false;
      }
      if (
        this.userData.preferredCurrency &&
        this.userData.preferredCurrency.fullName
      ) {
        $('#searchcurrency1').val(
          this.userData.preferredCurrency[
          'fullName' +
          (this.currentLang === 'en' ? '' : this.currentLang.toUpperCase())
          ]
        );
        $('#searchcurrency2').val(
          this.userData.preferredCurrency[
          'fullName' +
          (this.currentLang === 'en' ? '' : this.currentLang.toUpperCase())
          ]
        );
      }
      this.userService.setUserData(this.userData);
    } else {
      this.getLocalCurrencies().then((localCurrencies: any) => {
        this.userData.preferredLanguage =
          this.userData.preferredLanguage || 'en';
        if (typeof this.userData.preferredCurrency === 'string') {
          const currency = localCurrencies.find(
            (a) => a.shortName === this.userData.preferredCurrency
          );
          this.userData.preferredCurrency = currency || {};
          this.languageMessage = false;
        } else if (
          this.userData.preferredCurrency &&
          !this.userData.preferredCurrency.fullName
        ) {
          const currency = localCurrencies.find(
            (a) => a.shortName === this.userData.preferredCurrency.shortName
          );
          this.userData.preferredCurrency = currency || {};
          this.languageMessage = false;
        }
        $('#searchcurrency1').val(
          this.userData.preferredCurrency[
          'fullName' +
          (this.currentLang === 'en' ? '' : this.currentLang.toUpperCase())
          ]
        );
        $('#searchcurrency2').val(
          this.userData.preferredCurrency[
          'fullName' +
          (this.currentLang === 'en' ? '' : this.currentLang.toUpperCase())
          ]
        );

        this.userService.setUserData(this.userData);
        this.userService.changeUserData();
      });
    }

    this.currentLang = this.userData.preferredLanguage || 'en';
    this.getUnradNotifications();
    this.getCurrencies();
    route.events.subscribe((a) => {
      if (a instanceof NavigationEnd) {
        if (a.url === '/login') {
          this.disconnectNotification();
        }
      }
    });
  }

  async ngOnInit() {
    let urlLang = '';
    this.activeRoute.queryParams.subscribe((params) => {
      const token = params.token || localStorage.getItem('tokenApp');
      this.tokenApp = Boolean(token);
      if (this.tokenApp) {
        localStorage.setItem('tokenApp', token);
      }
      if (params.language) {
        urlLang = params.language;
      }
    });

    const cookiesExist = localStorage.getItem('firstTour')
      ? JSON.parse(localStorage.getItem('firstTour'))
      : null;
    if (cookiesExist == null) {
      this.showCookies = true;
      localStorage.setItem('cookies', JSON.stringify(true));
    } else {
      this.showCookies = cookiesExist;
    }

    if (this.tokenApp) {
      this.showCookies = false;
      $(document).ready(() => {
        setTimeout(() => {
          zendeskHide();
        }, 15000);
      });
    }

    let cookiesExist2 = this.cookieService.get('OBSIDIAM-COOKIES');
    if (cookiesExist2) {
      cookiesExist2 = JSON.parse(cookiesExist2);
      this.showCookies = cookiesExist2 === 'true';
    }

    $(document).on('click', (event) => {
      const $trigger = $('.drop_down').parent();
      if ($trigger !== event.target && !$trigger.has(event.target).length) {
        this.currencies = [];
        this.languages = [];
      }
    });
    this.dropDownsControl();

    if (!this.userData.verificationStatus) {
      this.getVerificationStatus();
    }

    $('.grecaptcha-badge').hide();
    if (
      this.userData.preferredCurrency &&
      this.userData.preferredCurrency.fullName
    ) {
      $('#searchcurrency1').val(
        this.userData.preferredCurrency[
        'fullName' +
        (this.currentLang === 'en' ? '' : this.currentLang.toUpperCase())
        ]
      );
      $('#searchcurrency2').val(
        this.userData.preferredCurrency[
        'fullName' +
        (this.currentLang === 'en' ? '' : this.currentLang.toUpperCase())
        ]
      );
    }
    this.userData.preferredLanguage =
      urlLang || this.userData.preferredLanguage;
    if (this.userData.preferredLanguage === 'en') {
      this.language = { lang: 'en', text: 'English' };
    } else if (this.userData.preferredLanguage === 'es') {
      this.language = { lang: 'es', text: 'Español' };
    } else if (this.userData.preferredLanguage === 'pt') {
      this.language = { lang: 'pt', text: 'Português' };
    }
    this.translate.setDefaultLang(this.language.lang);
    this.translate.use(this.language.lang);
    this.userService.updateReadNotificationEvent
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((m) => {
        this.getUnradNotifications();
      });
    this.userService.logoutEvent
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((m) => {
        if (this.stompClient && this.stompClient.connected) {
          this.stompClient.disconnect(() => {
            if (!environment.production) {
              console.log('notification disconnected=======');
            }
          });
        }
      });

    // Show tour in first login
    const firstTour = JSON.parse(localStorage.getItem('firstTour'));
    if (!environment.production) {
      console.log('FIRST', firstTour);
    }
    if (firstTour != null && firstTour) {
      this.userData.firstLoginTour = false;
      localStorage.setItem('firstTour', JSON.stringify(false));
      this.tourActiveService.activateTour('global', false, false);
      this.userService.setUserData(this.userData);
    }

    this.userService.changeLanguageEvent2
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((lang: any) => {
        this.userData = this.userService.getLoggedData();
        if (!environment.production) {
          // console.log('CHANGE', this.profileData.preferredLanguage, lang);
        }
        if (this.userData.preferredLanguage !== lang) {
          this.profileData.preferredLanguage = lang;

          this.languageMessage = true;
          $('#searchcurrency1').val(
            this.userData.preferredCurrency[
            'fullName' +
            (this.userData.preferredLanguage == 'en'
              ? ''
              : this.userData.preferredLanguage.toUpperCase())
            ]
          );
          $('#searchcurrency2').val(
            this.userData.preferredCurrency[
            'fullName' +
            (this.userData.preferredLanguage == 'en'
              ? ''
              : this.userData.preferredLanguage.toUpperCase())
            ]
          );
        }
        this.setLanguage();
      });

    const uuid = this.cookieService.get('firebaseUUID');
    if (!uuid) {
      if (this.userService.getBrowserName() !== 'safari') {
        const isSigning = await this.messagingService.SignIn(
          'pkjangra@gmail.com',
          'this.userData.userId'
        );
        // const isSigning = await this.messagingService.SignIn(
        //   "operations@obsidiam.com",
        //   "this.userData.userId"
        // );
        if (
          isSigning.message &&
          isSigning.message.indexOf('user-not-found') !== -1
        ) {
          const isRegister = await this.messagingService.SignUp(
            'pkjangra@gmail.com',
            'this.userData.userId'
          );
          // const isRegister = await this.messagingService.SignUp(
          //   "operations@obsidiam.com",
          //   "this.userData.userId"
          // );
          this.cookieService.set(
            'firebaseUUID',
            isRegister.user.uid,
            new Date(new Date().getTime() + 3600 * 24 * 365),
            '/',
            window.location.hostname,
            true,
            'Strict'
          );
          this.messagingService.changeVerificationStatus();
        } else {
          if (isSigning.user) {
            this.cookieService.set(
              'firebaseUUID',
              isSigning.user.uid,
              new Date(new Date().getTime() + 3600 * 24 * 365),
              '/',
              window.location.hostname,
              true,
              'Strict'
            );
          }
          this.messagingService.changeVerificationStatus();
        }
      }
    } else {
      this.messagingService.changeVerificationStatus();
    }
    this.walletService.change
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((isOpen) => {
        this.userData = this.userService.getLoggedData();
        $('#searchcurrency1').val(
          this.userData.preferredCurrency[
          'fullName' +
          (this.currentLang === 'en' ? '' : this.currentLang.toUpperCase())
          ]
        );
        $('#searchcurrency2').val(
          this.userData.preferredCurrency[
          'fullName' +
          (this.currentLang === 'en' ? '' : this.currentLang.toUpperCase())
          ]
        );
        this.setVerificationStatusString();
        this.getUnradNotifications();
      });
    this.userService.verificationEvent
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((isOpen) => {
        this.userData = this.userService.getLoggedData();
        this.setVerificationStatusString();
      });
    this.notificationSocket();
    this.userService.refreshTokenEvent
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((isOpen) => {
        this.getCurrencies();
      });

    const $this = this;
    $(document).click(function (e) {
      // console.log(($(e)), e);
      // if (!($(e.target).parent().hasClass('usd_div'))) {
      //   $this.currencies = [];
      // }
    });
    // $('#userProfile').click((event) => {
    //   event.stopPropagation();
    //   $('.drop_down_hd').slideToggle();
    // });

    $(document).click(() => {
      $('.drop_down_hd').slideUp();
      $('.bell_ic .drop_downN3').slideUp();
    });
    $('.switch input').click(() => {
      if ($('.switch input').is(':checked')) {
        $('body').addClass('nightMode');
        localStorage.setItem('MODE', 'night');
        $('.bgcolor').addClass('nightmode');
        $('.header').addClass('fixedblack');
        $('.whiteback').css('background-color', 'transparent');
        $('.textcolor').addClass('whitetext');
        $('.switch i').text('Night');
        $('.formstyle .select_region').addClass('darkselect');
        $('.selectBx i').css('color', '#fff');
        $('.code_div .form-control').css('color', '#fff');
        $('.modal-content').css('background-color', '#000');
        $('.home_fixed').addClass('homefixedmode');
        $('.gradient-box').addClass('homefixedmode');
        $('.sidebar').addClass('homefixedmode');
        $('.getverfiy').addClass('homefixedmode');
        $('.bellicon img').attr(
          'src',
          'https://cdn-dev.obsidiam.com/img/obsidiam_bellwhite.svg'
        );
        $('.searchicon img').attr(
          'src',
          'https://cdn-dev.obsidiam.com/img/obsidiam_searchwhite.svg'
        );
        $('.homemid').addClass('homemidmode');
        $('.stick_fixed').addClass('homemidmode');
        $('.bitcoin_sec').addClass('homemidmode');
        $('.drop_down').addClass('dropdownmode');
        $('.drop_down_hd').addClass('drop_down_hdmode');
        $('.drop_down2').addClass('drop_down_hdmode');
        $('.drop_downN3').addClass('drop_down_hdmode');
        $('.fran').addClass('homemidmode');
        $('.whitebackmodal').css('background-color', '#000');
        $('.partially').css('border-color', '#fff');
        $('.sendcoin').css('background-color', '#97a3b4');
        $('.btngran span').css('background', '#16252e');
        $('.dulpliimg img').attr(
          'src',
          'https://cdn-dev.obsidiam.com/img/obsidiam_whiteduplicate.svg'
        );
      } else {
        $('body').removeClass('nightMode');
        localStorage.setItem('MODE', 'day');
        $('.bgcolor').removeClass('nightmode');
        $('.header').removeClass('fixedblack');
        $('.whiteback').css('background-color', '#fff');
        $('.textcolor').removeClass('whitetext');
        $('.switch i').text('Day');
        $('.formstyle .select_region').removeClass('darkselect');
        $('.selectBx i').css('color', '#000');
        $('.code_div .form-control').css('color', '#98a9bc');
        $('.modal-content').css('background-color', '#fff');
        $('.home_fixed').removeClass('homefixedmode');
        $('.gradient-box').removeClass('homefixedmode');
        $('.sidebar').removeClass('homefixedmode');
        $('.getverfiy').removeClass('homefixedmode');
        $('.bellicon img').attr(
          'src',
          'https://cdn-dev.obsidiam.com/img/obsidiam_bell.svg'
        );
        $('.searchicon img').attr(
          'src',
          'https://cdn-dev.obsidiam.com/img/obsidiam_serch_black.svg'
        );
        $('.homemid').removeClass('homemidmode');
        $('.stick_fixed').removeClass('homemidmode');
        $('.bitcoin_sec').removeClass('homemidmode');
        $('.drop_down').removeClass('dropdownmode');
        $('.drop_down_hd').removeClass('drop_down_hdmode');
        $('.drop_down2').removeClass('drop_down_hdmode');
        $('.drop_downN3').removeClass('drop_down_hdmode');
        $('.fran').removeClass('homemidmode');
        $('.whitebackmodal').css('background-color', '#fff');
        $('.partially').css('border-color', '#0c133e');
        $('.sendcoin').css('background-color', 'rgba(12, 19, 62, 0.6)');
        $('.btngran span').css('background', '#fff');
        $('.dulpliimg img').attr(
          'src',
          'https://cdn-dev.obsidiam.com/img/obsidiam_duplicatebig.svg'
        );
      }
    });

    // $('.bell_ic .bell').click((event) => {
    //   if (!environment.production)
    //     console.log('Bell Clicked');
    //   $('.bell_ic .drop_down3').slideToggle();
    //   event.stopPropagation();

    // });

    $('.pkj-currency').css({
      height: $(window).height() - $('.home_fixed').height(),
    });
    $(window).resize(() => {
      $('.pkj-currency').css({
        height: $(window).height() - $('.home_fixed').height(),
      });
    });
    $(document).mouseup((e) => {
      const container = $('.pkj-currency').parent();

      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        $('.pkj-currency').hide();
      }
    });

    // Subscribe to Resize Screen Event
    $(window).resize(() => {
      if (window.innerWidth > 991) {
        $('.sidebar').css({ left: '0px', width: '185px' });
      } else {
        this.menuActive = false;
        $('.sidebar').css('left', '-250px');
      }
    });

    // Subscribe to Route Change
    this.router.events.pipe(takeUntil(this.unsubscribe$)).subscribe((event) => {
      if (event.constructor.name === 'NavigationStart') {
        this.menuActive = false;
      }
    });
    window.addEventListener('focus', () => {
      const tokenData = this.userService.getToken();
      if (!tokenData.token) {
        const urls = [
          '/',
          'market',
          'buy-sell-market',
          'simple-exchange-public',
          'quick-exchange-public',
          'advance-exchange',
          'about-us',
          'fee',
          'privacy-policy',
          'term-and-condition',
          'subscribe',
          'subscribe',
          'login',
          'forgot-password',
          'reset-password',
          'info',
          'confirmation',
          'verify-email',
          'verify-account',
          'change-phone',
          'check-sms-phone',
          'verification-error',
          'welcome',
          'verify',
        ];
        let redirect = true;
        for (let i = 0; i < urls.length; i++) {
          if (
            CustomUrlSerializer.decript(this.router.url).indexOf(
              '/' + urls[i]
            ) !== -1 ||
            CustomUrlSerializer.decript(this.router.url) === urls[i]
          ) {
            redirect = false;
          }
        }
        if (
          redirect &&
          CustomUrlSerializer.decript(this.router.url).indexOf(
            'simple-exchange-public'
          ) == -1 &&
          CustomUrlSerializer.decript(this.router.url).indexOf(
            'quick-exchange-public'
          ) == -1 &&
          CustomUrlSerializer.decript(this.router.url).indexOf(
            'advance-exchange'
          )
        ) {
          this.cookieService.deleteAll('/', location.hostname);
          this.userService.deleteUserData();
          this.userService.deleteToken();
          this.userService.isLoggedIn = false;
          this.messagingService.changeVerificationStatus();

          localStorage.clear();

          if (!environment.production) {
            console.log('HEADER 631: HIT LOG OUT EVENT');
          }
          this.userService.logOutEventHit();
          this.route.navigate(['/login']);
        }
      }
    });
  }

  getLocalCurrencies() {
    return new Promise((resolve, reject) => {
      let localCurrencies = localStorage.getItem('OBSIDIAM-LOCAL-CURRENCIES');
      if (localCurrencies) {
        resolve(JSON.parse(localCurrencies) || []);
      } else {
        this.walletService
          .getCurrencies(this.userData.token)
          .pipe(takeUntil(this.unsubscribe$))
          .toPromise().then((m: any) => {
            if (m.status === 200) {
              localStorage.setItem(
                'OBSIDIAM-LOCAL-CURRENCIES',
                JSON.stringify(m.data)
              );
              localCurrencies = localStorage.getItem(
                'OBSIDIAM-LOCAL-CURRENCIES'
              );
              resolve(m.data);
            }
          });
      }
    });
  }

  disconnectNotification() {
    if (this.stompClient && this.stompClient.connected) {
      this.stompClient.disconnect(() => {
        if (!environment.production) {
          console.log('disconnect notification socket');
        }
      });
    }
    $('.sidebar .logout').addClass('disabled');
  }

  getCurrencies() {
    this.userData = this.userService.getLoggedData();
    const localCurrencies = localStorage.getItem('OBSIDIAM-LOCAL-CURRENCIES');
    if (localCurrencies) {
      this.allCurrencies = this.allCurrencies1 = JSON.parse(localCurrencies);
      this.resizeAmount();
      const current = this.allCurrencies.filter((c) => {
        if (
          this.userData &&
          this.userData.preferredCurrency &&
          this.userData.preferredCurrency.shortName &&
          c.shortName &&
          c.shortName === this.userData.preferredCurrency.shortName
        ) {
          this.userData.preferredCurrency = c;
          $('#searchcurrency1').val(
            this.userData.preferredCurrency[
            'fullName' +
            (this.currentLang === 'en'
              ? ''
              : this.currentLang.toUpperCase())
            ]
          );
          $('#searchcurrency2').val(
            this.userData.preferredCurrency[
            'fullName' +
            (this.currentLang === 'en'
              ? ''
              : this.currentLang.toUpperCase())
            ]
          );
          this.userService.setUserData(this.userData);
          this.userService.changeUserData();
          this.currentCurrency = c;
          return true;
        } else {
          return false;
        }
      });
      if (
        this.userData &&
        this.userData.preferredCurrency &&
        typeof this.userData.preferredCurrency === 'object'
      ) {
        this.usdDollar = this.allCurrencies.filter(
          (currency) =>
            currency.shortName === this.userData.preferredCurrency.shortName
        )[0];
        this.allCurrencies = this.allCurrencies1.filter(
          (currency) =>
            currency.shortName !== this.userData.preferredCurrency.shortName
        );
      }
    } else {
      this.walletService
        .getCurrencies(this.userData.token)
        .pipe(takeUntil(this.unsubscribe$))
        .toPromise().then((m: any) => {
          if (m.status === 200) {
            this.allCurrencies = this.allCurrencies1 = m.data;
            localStorage.setItem(
              'OBSIDIAM-LOCAL-CURRENCIES',
              JSON.stringify(m.data)
            );
            const current = this.allCurrencies.filter((c) => {
              if (
                this.userData &&
                this.userData.preferredCurrency &&
                c.shortName === this.userData.preferredCurrency.shortName
              ) {
                this.userData.preferredCurrency.value = c.value;
                this.userData.preferredCurrency.symbol = c.symbol;
                this.userData.preferredCurrency.fullName = c.fullName;
                $('#searchcurrency1').val(
                  this.userData.preferredCurrency[
                  'fullName' +
                  (this.currentLang === 'en'
                    ? ''
                    : this.currentLang.toUpperCase())
                  ]
                );
                $('#searchcurrency2').val(
                  this.userData.preferredCurrency[
                  'fullName' +
                  (this.currentLang === 'en'
                    ? ''
                    : this.currentLang.toUpperCase())
                  ]
                );
                this.userService.setUserData(this.userData);
                this.userService.changeUserData();
                this.currentCurrency = c;
                return true;
              } else {
                return false;
              }
            });
            if (
              this.userData &&
              this.userData.preferredCurrency &&
              typeof this.userData.preferredCurrency === 'object'
            ) {
              this.usdDollar = this.allCurrencies.filter(
                (currency) =>
                  currency.shortName ===
                  this.userData.preferredCurrency.shortName
              )[0];
              this.allCurrencies = this.allCurrencies1.filter(
                (currency) =>
                  currency.shortName !==
                  this.userData.preferredCurrency.shortName
              );
            }
          }
        });
    }
  }

  getUnradNotifications() {
    this.userService
      .getUnreadNotifications(this.userData.token)
      .pipe(takeUntil(this.unsubscribe$))
      .toPromise().then((m: any) => {
        if (m.status === 200) {
          this.notifiations = m.data.sort((a, b) => {
            if (a.id < b.id) {
              return 1;
            }
            if (a.id > b.id) {
              return -1;
            }
            // names must be equal
            return 0;
          });
          // if (environment.production) {
          //   console.log(this.notifiations)
          // }

          this.userService.unreadNotifications(this.notifiations);
        }
      });
  }

  //SELECT ALL THE NOTIFICATION
  selectAllNotiButton(event) {
    this.selectAllNotification = true;
    this.activeDeleteOption = false;
    this.arrNotification = [];
    this.numberOfChecked = 0;
    $('input:checkbox').prop('checked', true);
    for (let i = 0; i < this.notifiations.length; i++) {
      $('.notificationDiv ul li:nth-child(' + (i + 1) + ')')
        .css('background-color', 'rgba(32, 202, 254, 0.1)')
        .off('mouseenter mouseleave');
    }
    if ($('input:checkbox').is(':checked')) {
      for (let i of this.notifiations) {
        this.arrNotification.push(i);
      }
    }
    $('.bell_ic .drop_downN3').click((event) => {
      event.stopPropagation();
    });
  }

  //UNSELECT THE NOTIFICATION WHEN YOU SELECT THE CHECKBOX IN NOTIFICATION HEADER
  checkedEvent(event) {
    if (event.target.checked) {
      for (let i = 0; i < this.notifiations.length; i++) {
        $(`#flexCheckDefault_${i}`).prop('checked', true);
        $('.notificationDiv ul li:nth-child(' + (i + 1) + ')').css(
          'background',
          'rgba(32, 202, 254, 0.1)'
        );
        this.selectAllNotification = true;
        this.activeDeleteOption = false;
        $('.bell_ic .drop_downN3').click((event) => {
          event.stopPropagation();
        });
      }
    } else {
      for (let i = 0; i < this.notifiations.length; i++) {
        $(`#flexCheckDefault_${i}`).prop('checked', false);
        this.selectAllNotification = false;
        this.activeDeleteOption = false;
        $('.notificationDiv ul li:nth-child(' + (i + 1) + ')')
          .css('background', 'transparent')
          .hover(function (e) {
            $(this).css(
              'background-color',
              e.type === 'mouseenter'
                ? 'rgba(32, 202, 254, 0.1)'
                : 'transparent'
            );
          });
        $('.bell_ic .drop_downN3').click((event) => {
          event.stopPropagation();
        });
      }
      this.arrNotification = [];
      this.numberOfChecked = 0;
    }
  }

  countChecked() {
    setTimeout(() => {
      // this.numberOfChecked = $('input:checkbox:checked').length;
      this.numberOfChecked = this.arrNotification.length;
    }, 50);
  }

  //SELECT A SPECIFIC NOTIFICATION
  selectNotification(event, val) {
    this.idSelectCheckBox = event.target.id;
    if (event.target.checked) {
      this.arrNotification.push(val);
      this.notificationSelected = true;
      this.activeDeleteOption = true;
      for (let i = 0; i < this.notifiations.length; i++) {
        if ($(`#flexCheckDefault_${i}`).is(':checked')) {
          $('.notificationDiv ul li:nth-child(' + (i + 1) + ')')
            .css('background', 'rgba(32, 202, 254, 0.1)')
            .off('mouseenter mouseleave');
          $('.bell_ic .drop_downN3').click((event) => {
            event.stopPropagation();
          });
        }
      }
      if (
        ($('#flexCheckDefault').is(':checked')
          ? this.numberOfChecked - 1
          : this.numberOfChecked) === this.notifiations.length
      ) {
        $('input:checkbox').prop('checked', true);
        this.selectAllNotification = true;
        this.activeDeleteOption = false;
      }
    } else {
      for (let j = 0; j < this.arrNotification.length; j++) {
        if (this.arrNotification[j].id === val.id) {
          let value = (element) => element.id == val.id;
          let index = this.arrNotification.findIndex(value);
          this.arrNotification.splice(index, 1);
        }
      }
      for (let i = 0; i < this.notifiations.length; i++) {
        if (!$(`#flexCheckDefault_${i}`).is(':checked')) {
          $('.notificationDiv ul li:nth-child(' + (i + 1) + ')')
            .css('background', 'transparent')
            .hover(function (e) {
              $(this).css(
                'background-color',
                e.type === 'mouseenter'
                  ? 'rgba(32, 202, 254, 0.1)'
                  : 'transparent'
              );
              $('.bell_ic .drop_downN3').click((event) => {
                event.stopPropagation();
              });
            });
        }
      }
      if (this.numberOfChecked <= 1) {
        this.notificationSelected = false;
      }
      if (
        this.selectAllNotification === true &&
        this.numberOfChecked <= this.notifiations.length
      ) {
        this.selectAllNotification = false;
        this.activeDeleteOption = true;
        this.notificationSelected = true;
      }
    }

    setTimeout(() => {
      if (this.notifiations.length == this.arrNotification.length) {
        $('input:checkbox').prop('checked', true);
        this.selectAllNotification = true;
        this.activeDeleteOption = false;
      }
    }, 200);
  }

  //UPDATE THE NOTIFICATION SELECTED
  updateNotification() {
    for (let i = 0; i < this.arrNotification.length; i++) {
      this.userService
        .updateNotificationSeen(this.arrNotification[i].id, this.userData.token)
        .pipe(takeUntil(this.unsubscribe$))
        .toPromise().then((m: any) => {
          this.getUnradNotifications();
          this.selectAllNotification = false;
          this.activeDeleteOption = false;
          $('input:checkbox').prop('checked', false);
          this.arrNotification = [];
          this.numberOfChecked = 0;
        });
    }
  }

  readAllNotifications() {
    this.selectAllNotification = false;
    this.notificationSelected = false;
    this.userService
      .updateAllNotificationSeen(this.userData.token)
      .pipe(takeUntil(this.unsubscribe$))
      .toPromise().then((m: any) => {
        if (m.status === 200) {
          this.getUnradNotifications();
          $('.modal').modal('hide');
          this.arrNotification = [];
          this.numberOfChecked = 0;
        }
      });
  }

  readNootification(n) {
    if (!n.seenStatus) {
      this.userService
        .updateNotificationSeen(n.id, this.userData.token)
        .pipe(takeUntil(this.unsubscribe$))
        .toPromise().then((m: any) => {
          $(".modal").modal("hide");
          this.getUnradNotifications();
          if (n.notificationType === 'userAdded') {
            this.route.navigate(['quick-transfer']);
          }
          if (n.notificationType === 'quickTransferReceived') {
            this.route.navigate(['transfer-history', 'received']);
          }
          if (n.notificationType === 'quickTransferSent') {
            this.route.navigate(['transfer-history']);
          }
          /* */
          if (n.notificationType === 'verification') {
            this.userService.changeUserData();
            this.route.navigate(['profile', 'verification']);
          }
          if (
            n.notificationType === 'deposit' ||
            n.notificationType === 'withdraw'
          ) {
            if (n.coin) {
              this.route.navigate(
                [
                  n.notificationType === 'withdraw'
                    ? 'withdrawals'
                    : n.notificationType,
                ],
                { queryParams: { coin: n.coin } }
              );
            } else {
              this.route.navigate([
                n.notificationType === 'withdraw'
                  ? 'withdrawals'
                  : n.notificationType,
              ]);
            }
          }
          if (n.notificationType === 'feedbackReceived') {
            this.route.navigate(['profile', 'reputation']);
          }
          if (n.notificationType === 'paymentApproved') {
            if (this.route.url == '/trade-window/' + n.orderId) {
              this.userService.updateTrade(n.orderId);
            } else {
              this.userService.changeUserData(n.orderId);
            }
            this.route.navigate(['trade-window', n.orderId]);
          }
          if (n.notificationType === 'paymentSent') {
            if (this.route.url == '/trade-window/' + n.orderId) {
              this.userService.updateTrade(n.orderId);
            } else {
              this.userService.changeUserData(n.orderId);
            }
            this.route.navigate(['trade-window', n.orderId]);
          }
          if (n.notificationType === 'firstPaymentSent') {
            if (this.route.url == '/trade-window/' + n.orderId) {
              this.userService.updateTrade(n.orderId);
            } else {
              this.userService.changeUserData(n.orderId);
            }
            this.route.navigate(['trade-window', n.orderId]);
          }
          if (n.notificationType === 'titleTransferred') {
            if (this.route.url == '/trade-window/' + n.orderId) {
              this.userService.updateTrade(n.orderId);
            } else {
              this.userService.changeUserData(n.orderId);
            }
            this.route.navigate(['trade-window', n.orderId]);
          }
          if (n.notificationType === 'capitalTransferred') {
            if (this.route.url == '/trade-window/' + n.orderId) {
              this.userService.updateTrade(n.orderId);
            } else {
              this.userService.changeUserData(n.orderId);
            }
            this.route.navigate(['trade-window', n.orderId]);
          }
          if (n.notificationType === 'firstPaymentApproved') {
            if (this.route.url == '/trade-window/' + n.orderId) {
              this.userService.updateTrade(n.orderId);
            } else {
              this.userService.changeUserData(n.orderId);
            }
            this.route.navigate(['trade-window', n.orderId]);

          }
          if (n.notificationType === 'orderTaken') {
            // this.getApprovalData(n);
            this.route.navigate(['trade-window', n.orderId]);
          }
          if (n.notificationType === 'orderCancelled') {
            if (n.privateOrder) {
              this.route.navigate(['private-trade']);
            } else {
              this.route.navigate(['orders']);
            }
          }
          if (n.notificationType === 'orderApproved') {
            if (this.route.url == '/trade-window/' + n.orderId) {
              this.userService.updateTrade(n.orderId);
            } else {
              this.userService.changeUserData(n.orderId);
            }
            this.route.navigate(['trade-window', n.orderId]);
          }
          if (n.notificationType === 'increasePaymentTimeRequested') {
            if (this.route.url == '/trade-window/' + n.orderId) {
              this.userService.updateTrade(n.orderId);
            } else {
              this.userService.changeUserData(n.orderId);
            }
            this.route.navigate(['trade-window', n.orderId]);
          }
          if (n.notificationType === 'increasePaymentTimeApproved') {
            if (this.route.url == '/trade-window/' + n.orderId) {
              this.userService.updateTrade(n.orderId);
            } else {
              this.userService.changeUserData(n.orderId);
            }

            this.route.navigate(['trade-window', n.orderId]);
          }
          if (
            n.notificationType === 'increasePaymentTimeRejected' ||
            n.notificationType === 'disputeTriggered'
          ) {
            if (this.route.url == '/trade-window/' + n.orderId) {
              this.userService.updateTrade(n.orderId);
            } else {
              this.userService.changeUserData(n.orderId);
            }

            this.route.navigate(['trade-window', n.orderId]);
          }
          if (n.notificationType === 'message') {
            if (this.route.url == '/trade-window/' + n.orderId) {
              this.userService.updateTrade(n.orderId);
            } else {
              this.userService.changeUserData(n.orderId);
            }
            this.route.navigate(['trade-window', n.orderId]);
          }
          if (n.notificationType === 'disputeRejected') {
            this.userService.tradeResolved();
            if (n.privateOrder) {
              this.route.navigate([
                'private-trade',
                { queryParams: { activeTab: 'COMPLETED' } },
              ]);
            } else {
              this.route.navigate(['orders'], {
                queryParams: { activeTab: 'COMPLETED' },
              });
            }
          }
          if (n.notificationType === 'disputeResolved') {
            this.userService.tradeResolved();
            if (n.privateOrder) {
              this.route.navigate([
                'private-trade',
                { queryParams: { activeTab: 'COMPLETED' } },
              ]);
            } else {
              this.route.navigate(['orders'], {
                queryParams: { activeTab: 'COMPLETED' },
              });
            }
          }
          if (n.notificationType === 'referralEarning') {
            this.route.navigate(['profile', 'referral-program']);
          }
        });
    } else {
      if (n.notificationType === 'userAdded') {
        this.route.navigate(['quick-transfer']);
      }
      if (n.notificationType === 'quickTransferReceived') {
        this.route.navigate(['transfer-history', 'received']);
      }
      if (n.notificationType === 'quickTransferSent') {
        this.route.navigate(['transfer-history']);
      }

      if (n.notificationType === 'verification') {
        this.route.navigate(['profile', 'verification']);
      }
      if (
        n.notificationType === 'deposit' ||
        n.notificationType === 'withdraw'
      ) {
        if (n.coin) {
          this.route.navigate(
            [
              n.notificationType === 'withdraw'
                ? 'withdrawals'
                : n.notificationType,
            ],
            { queryParams: { coin: n.coin } }
          );
        } else {
          this.route.navigate([
            n.notificationType === 'withdraw'
              ? 'withdrawals'
              : n.notificationType,
          ]);
        }
      }
      if (n.notificationType === 'feedbackReceived') {
        this.route.navigate(['profile', 'reputation']);
      }
      if (n.notificationType === 'paymentApproved') {
        if (this.route.url == '/trade-window/' + n.orderId) {
          this.userService.updateTrade(n.orderId);
        } else {
          this.userService.changeUserData(n.orderId);
        }

        this.route.navigate(['trade-window', n.orderId]);
      }
      if (n.notificationType === 'paymentSent') {
        if (this.route.url == '/trade-window/' + n.orderId) {
          this.userService.updateTrade(n.orderId);
        } else {
          this.userService.changeUserData(n.orderId);
        }

        this.route.navigate(['trade-window', n.orderId]);
      }
      if (n.notificationType === 'orderTaken') {
        // this.getApprovalData(n);
        this.route.navigate(['trade-window', n.orderId]);
      }
      if (n.notificationType === 'orderCancelled') {
        if (n.privateOrder) {
          this.route.navigate(['private-trade']);
        } else {
          this.route.navigate(['orders']);
        }
      }
      if (n.notificationType === 'orderApproved') {
        if (this.route.url == '/trade-window/' + n.orderId) {
          this.userService.updateTrade(n.orderId);
        } else {
          this.userService.changeUserData(n.orderId);
        }

        this.route.navigate(['trade-window', n.orderId]);
      }
      if (n.notificationType === 'increasePaymentTimeRequested') {
        if (this.route.url == '/trade-window/' + n.orderId) {
          this.userService.updateTrade(n.orderId);
        } else {
          this.userService.changeUserData(n.orderId);
        }

        this.route.navigate(['trade-window', n.orderId]);
      }
      if (n.notificationType === 'increasePaymentTimeApproved') {
        if (this.route.url == '/trade-window/' + n.orderId) {
          this.userService.updateTrade(n.orderId);
        } else {
          this.userService.changeUserData(n.orderId);
        }

        this.route.navigate(['trade-window', n.orderId]);
      }
      if (
        n.notificationType === 'increasePaymentTimeRejected' ||
        n.notificationType === 'disputeTriggered'
      ) {
        if (this.route.url == '/trade-window/' + n.orderId) {
          this.userService.updateTrade(n.orderId);
        } else {
          this.userService.changeUserData(n.orderId);
        }

        this.route.navigate(['trade-window', n.orderId]);
      }
      if (n.notificationType === 'message') {
        this.route.navigate(['trade-window', n.orderId]);
      }
      if (n.notificationType === 'disputeRejected') {
        this.userService.tradeResolved();
        if (n.privateOrder) {
          this.route.navigate([
            'private-trade',
            { queryParams: { activeTab: 'COMPLETED' } },
          ]);
        } else {
          this.route.navigate(['orders'], {
            queryParams: { activeTab: 'COMPLETED' },
          });
        }
      }
      if (n.notificationType === 'disputeResolved') {
        this.userService.tradeResolved();
        if (n.privateOrder) {
          this.route.navigate([
            'private-trade',
            { queryParams: { activeTab: 'COMPLETED' } },
          ]);
        } else {
          this.route.navigate(['orders'], {
            queryParams: { activeTab: 'COMPLETED' },
          });
        }
      }
      if (n.notificationType === 'referralEarning') {
        this.route.navigate(['profile', 'referral-program']);
      }
    }
  }

  getApprovalData(nt) {
    this.selectedOrder = nt;
    this.otcService
      .getDataForApproval(nt.orderId, this.userData.token)
      .pipe(takeUntil(this.unsubscribe$))
      .toPromise().then((m: any) => {
        if (m.status === 200) {
          this.approvalData = m.data;
          $('#approve-order-header').modal('show');
        } else if (m.status === 409) {
          this.route.navigate(['/trade-window', nt.orderId]);
        } else {
          this.translate
            .get('error')
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((er: any) => {
              const err = er;
              this.toast.error(m.message, err, {
                timeOut: 15000,
              });
            });
        }
      });
  }

  approveOrder(status) {
    if (!this.loading) {
      this.loading = true;
      const data = {
        approved: status,
        orderActionId: this.approvalData.orderActionId,
      };
      this.otcService
        .approveOrder(data, this.userData.token)
        .pipe(takeUntil(this.unsubscribe$))
        .toPromise().then((m: any) => {
          if (m.status === 200) {
            $('.modal').modal('hide');
            this.translate
              .get('success')
              .pipe(takeUntil(this.unsubscribe$))
              .subscribe((er: any) => {
                const msg = m.message;
                const err = er;
                this.loading = false;
                this.toast.success(msg, err, {
                  timeOut: 15000,
                });
              });
            if (data.approved) {
              if (
                this.route.url ==
                '/trade-window/' + this.approvalData.orderActionId
              ) {
                this.userService.updateTrade(this.approvalData.orderActionId);
              } else {
                this.userService.changeUserData(
                  this.approvalData.orderActionId
                );
              }
              this.route.navigate([
                'trade-window',
                this.approvalData.orderActionId,
              ]);
            } else {
              if (this.approvalData.orderActionId.privateOrder) {
                this.route.navigate([
                  'private-trade',
                  { queryParams: { activeTab: 'COMPLETED' } },
                ]);
              } else {
                this.route.navigate(['/orders'], {
                  queryParams: { activeTab: 'COMPLETED' },
                });
              }
            }
          } else {
            this.loading = false;
            this.translate
              .get('error')
              .pipe(takeUntil(this.unsubscribe$))
              .subscribe((er: any) => {
                const err = er;
                if (m.status == 409) {
                  $('.modal').modal('hide');
                }
                this.toast.error(m.message, err, {
                  timeOut: 15000,
                });
              });
          }
        });
    }
  }

  searchCurrency(event) {
    if (!this.currencies.length) {
      this.currencies = this.allCurrencies.sort((a, b) => {
        if (
          a[
          'fullName' +
          (this.currentLang == 'en' ? '' : this.currentLang.toUpperCase())
          ] <
          b[
          'fullName' +
          (this.currentLang == 'en' ? '' : this.currentLang.toUpperCase())
          ]
        ) {
          return -1;
        }
        if (
          a[
          'fullName' +
          (this.currentLang == 'en' ? '' : this.currentLang.toUpperCase())
          ] >
          b[
          'fullName' +
          (this.currentLang == 'en' ? '' : this.currentLang.toUpperCase())
          ]
        ) {
          return 1;
        }
        // names must be equal
        return 0;
      });
    } else {
      this.currencies = [];
    }
  }

  /*async activeUserSocket() {
    const url = environment.apiUrl + environment.socketUrl;;
    const socket = new SockJS(url);
    if (socket.readyState === WebSocket.OPEN) {
      socket.close();
    }
    this.stompClientActiveUser = Stomp.over(socket);
    if (environment.production) {
      this.stompClientActiveUser.debug = () => {
      };
    }
    const token = this.userService.getToken();
    await this.stompClientActiveUser.connect({
      Authorization: 'Bearer ' + token.token
    }, (frame) => {
      if (!environment.production) {
        console.log('active usersocket connected:', true);
      }
      this.stompClientActiveUser.pipe(takeUntil(this.unsubscribe$)).subscribe('/users/topic', (greeting) => {
        if (!environment.production) {
          console.log('after cative subscribe:', JSON.parse(greeting.body), greeting);
        }
        const obj = JSON.parse(greeting.body);
        if (!environment.production) {
          console.log(obj);
        }
      });

    }, (err) => {
      if (!environment.production) {
        console.log('Socket disconnect automatically', err);
      }
      if (this.stompClientActiveUser.connected) {
        this.stompClientActiveUser.disconnect(() => {
          if (!environment.production) {
            console.log('disconnect user socket');
          }
        });
      }
      this.activeUserSocket();
    });
  }*/

  async notificationSocket() {
    const url = environment.apiUrl + environment.socketUrl;
    const socket = new SockJS(url);
    if (socket.readyState === WebSocket.OPEN) {
      socket.close();
    }
    this.stompClient = Stomp.over(socket);
    this.stompClient.reconnect_delay = 5000;
    this.stompClient.heartbeatIncoming = 4000;
    this.stompClient.heartbeatOutgoing = 4000;
    this.stompClient.heartbeat.outgoing = 4000;
    this.stompClient.heartbeat.incoming = 4000;
    if (this.stompClient.connected) {
      this.stompClient.disconnect(() => {
        if (!environment.production) {
          console.log('disconnect notification socket');
        }
      });
    }
    if (environment.production) {
      this.stompClient.debug = () => {
      };
    }
    const token = this.userService.getToken();
    // this.stompClient.heartbeat.outgoing = 0;
    // this.stompClient.heartbeat.incoming = 20000;
    await this.stompClient.connect(
      {
        Authorization: 'Bearer ' + token.token,
      },
      (frame) => {
        $('.sidebar .logout').removeClass('disabled');
        if (!environment.production) {
          console.log('socket notification connected:', true);
        }
        if (this.route.url === '/login') {
          this.disconnectNotification();
        }
        this.stompClient.subscribe('/user/topic/notification', (greeting) => {
          this.userData = this.userService.getLoggedData();
          this.route.events.subscribe((a) => {
            if (a instanceof NavigationEnd) {
              if (a.url === '/login') {
                this.disconnectNotification();
              }
            }
          });
          if (this.route.url === '/login') {
            this.disconnectNotification();
          }
          // if (!environment.production) {
          //   console.log('after notification subscribe:', JSON.parse(greeting.body), greeting);
          // }
          const obj = JSON.parse(greeting.body);
          if (obj.notificationType !== 'newLogin') {
            this.userService.updateNotification();
            if (
              [
                'orderTaken',
                'orderApproved',
                'orderCancelled',
                'paymentApproved',
                'feedbackReceived',
                'paymentSent',
                'firstPaymentSent',
                'firstPaymentApproved',
                'capitalTransferred',
                'titleTransferred',
                'disputeRejected',
                'disputeTriggered',
                'increasePaymentTimeApproved',
                'increasePaymentTimeRequested',
              ].indexOf(obj.notificationType) !== -1
            ) {
              this.userService.updateTrade(obj.orderId);
              // console.log(obj);
            }
            if (['onboarding_stage_7'].indexOf(obj.notificationType) !== -1) {
              this.router.navigate([
                '/obsicash/bluebankonboarding/ending-process',
              ]);
              this.obsicashStore.onboardingBlueBank.stage = 7;
            }
            if (['onboarding_stage_8'].indexOf(obj.notificationType) !== -1) {
              this.router.navigate([
                '/obsicash/bluebankonboarding/ending-process',
              ]);
              this.obsicashStore.onboardingBlueBank.stage = 7;
              this.obsicashStore.onboardingBlueBank.reviewReasonEn = obj.aux1;
              this.obsicashStore.onboardingBlueBank.reviewReasonEs = obj.aux2;
            }
            if (['onboarding_stage_9'].indexOf(obj.notificationType) !== -1) {
              this.router.navigate([
                '/obsicash/bluebankonboarding/ending-process',
              ]);
              this.obsicashStore.onboardingBlueBank.stage = 9;
              this.obsicashStore.onboardingBlueBank.bankReason = obj.aux1;
            }
            if (['onboarding_stage_10'].indexOf(obj.notificationType) !== -1) {
              this.router.navigate([
                '/obsicash/bluebankonboarding/ending-process',
              ]);
              this.obsicashStore.onboardingBlueBank.stage = 10;
            }
            if (['onboarding_stage_11'].indexOf(obj.notificationType) !== -1) {
              this.router.navigate([
                '/obsicash/bluebankonboarding/ending-process',
              ]);
              this.obsicashStore.onboardingBlueBank.stage = 11;
            }
            if (['onboarding_finish'].indexOf(obj.notificationType) !== -1) {
              this.router.navigate(['/dashboard']);
            }
            if (['cashOutFinished'].indexOf(obj.notificationType) !== -1) {
              this.obsicashStore.fetchAllTransactionHistory();
              this.obsicashStore.fetchAllAccountWalletsObsicash();
              this.obsicashStore.fetchAllAccountsBank();
              this.obsicashStore.fetchAllAccountWallets();
              this.obsicashStore.getAllCurrencies();
              this.obsicashStore.getAllFiatAccount(this.userData.preferredLanguage).then();
            }
            if (['cashOutFinishedAdmin'].indexOf(obj.notificationType) !== -1) {
              this.obsicashStore.fetchAllTransactionHistory();
              this.obsicashStore.fetchAllAccountWalletsObsicash();
              this.obsicashStore.fetchAllAccountsBank();
              this.obsicashStore.fetchAllAccountWallets();
              this.obsicashStore.getAllCurrencies();
              this.obsicashStore.getAllFiatAccount(this.userData.preferredLanguage).then();
            }
            if (['cashInFinished'].indexOf(obj.notificationType) !== -1) {
              this.obsicashStore.fetchAllTransactionHistory();
              this.obsicashStore.fetchAllAccountWalletsObsicash();
              this.obsicashStore.fetchAllAccountsBank();
              this.obsicashStore.fetchAllAccountWallets();
              this.obsicashStore.getAllCurrencies();
              this.obsicashStore.getAllFiatAccount(this.userData.preferredLanguage).then();
            }
            if (['cashInFinishedAdmin'].indexOf(obj.notificationType) !== -1) {
              this.obsicashStore.fetchAllTransactionHistory();
              this.obsicashStore.fetchAllAccountWalletsObsicash();
              this.obsicashStore.fetchAllAccountsBank();
              this.obsicashStore.fetchAllAccountWallets();
              this.obsicashStore.getAllCurrencies();
              this.obsicashStore.getAllFiatAccount(this.userData.preferredLanguage).then();
            }
            if (
              ['reputationImportAccepted'].indexOf(obj.notificationType) !== -1
            ) {
              this.userService.websiteReputation();
            }
            if (['withdraw', 'deposit'].indexOf(obj.notificationType) !== -1) {
              this.userService.changeUserData();
            }
            if (
              ['quickTransferReceived'].indexOf(obj.notificationType) !== -1
            ) {
              this.userService.changeUserData();
            }

            if (['quickTransferSent'].indexOf(obj.notificationType) !== -1) {
              this.userService.changeUserData();
            }
            /* */
            if (['verification'].indexOf(obj.notificationType) !== -1) {
              this.getVerificationStatus();
              this.obsicashStore.fetchAllInfoUserDocuments();
            }
            if (['disputeResolved'].indexOf(obj.notificationType) !== -1) {
              this.userService.tradeResolved();
              let url = CustomUrlSerializer.decript(this.route.url);
              if (url === '/trade-window/' + obj.orderId) {
                if (obj.privateOrder) {
                  this.route.navigate([
                    'private-trade',
                    { queryParams: { activeTab: 'COMPLETED' } },
                  ]);
                } else {
                  this.route.navigate(['orders'], {
                    queryParams: { activeTab: 'COMPLETED' },
                  });
                }
              }
            }
            if (['orderCancelled'].indexOf(obj.notificationType) !== -1) {
              this.userService.tradeResolved();
              if (this.route.url == '/trade-window/' + obj.orderId) {
                if (obj.privateOrder) {
                  this.route.navigate(['private-trade'], {
                    queryParams: { activeTab: 'COMPLETED' },
                  });
                } else {
                  this.route.navigate(['orders'], {
                    queryParams: { activeTab: 'COMPLETED' },
                  });
                }
              }
            }
            if (['blockedCheckEmail'].indexOf(obj.notificationType) !== -1) {
              $('#blocked-popup').modal({
                backdrop: 'static',
                keyboard: false,
              });
              $('#blocked-popup').modal('show');
              this.blockedMessage = obj.message;
            }
            try {
              const audio = new Audio('../../../assets/ring.mp3');
              var promise = audio.play();
              if (promise !== undefined) {
                promise
                  .then((_) => {
                  })
                  .catch((error) => {
                    if (!environment.production) {
                      console.log(error);
                    }
                  });
              }
            } catch (e) {
              if (!environment.production) {
                console.log(e);
              }
            }
            this.notifiations.push(obj);
            this.isClicked = true;
            const tost = this.toast.info(obj.message, obj.title, {
              closeButton: true,
              tapToDismiss: false,
              enableHtml: true,
              timeOut: 15000,
            });

            tost.onTap.subscribe(() => {
              this.readNootification(obj);
            });
            tost.onHidden.subscribe((a) => {
              $('body').removeClass('modal-open');
            });
            this.notifiations = this.notifiations.sort((a, b) => {
              if (a.id < b.id) {
                return 1;
              }
              if (a.id > b.id) {
                return -1;
              }
              // names must be equal
              return 0;
            });
            this.userService.unreadNotifications(this.notifiations);
            this.selectAllNotification = false;
            this.activeDeleteOption = true;
          } else {
            if (this.userData.loginId !== obj.id) {
              this.translate
                .get('multiple_session')
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((n: any) => {
                  this.translate
                    .get('error')
                    .pipe(takeUntil(this.unsubscribe$))
                    .subscribe((er: any) => {
                      const msg = n;
                      const err = er;
                      this.toast.error(msg, err, {
                        timeOut: 15000,
                      });

                      this.logOut();
                    });
                });
            }
          }
        });
        this.stompClient.subscribe('/topic/notification', (greeting) => {
          const obj = JSON.parse(greeting.body);
          if (!environment.production) {
            // console.log('User Online====>', obj);
          }
          this.userService.userOnline(obj);
        });
      },
      (err) => {
        if (!environment.production) {
          console.log('Socket disconnect automatically', err);
        }
        /*setTimeout(() => {
        this.notificationSocket();
      }, 2000);*/
      }
    );
  }

  logOut() {
    $('.modal').modal('hide');

    const isMobile =
      typeof window.orientation !== 'undefined' ||
      navigator.userAgent.indexOf('IEMobile') !== -1;
    const data = {
      source: isMobile ? 'Mobile' : 'Website',
    };
    this.userService
      .logout(data, this.userData.token)
      .pipe(takeUntil(this.unsubscribe$))
      .toPromise().then((n: any) => {
        if (n.status === 200) {
          this.cookieService.deleteAll('/', location.hostname);
          this.userService.deleteUserData();
          this.userService.deleteToken();
          this.userService.setUserData({});
          this.userService.setToken('');
          this.userService.isLoggedIn = false;
          this.messagingService.changeVerificationStatus();

          localStorage.clear();

          if (!environment.production) {
            console.log('HEADER 631: HIT LOG OUT EVENT');
          }
          this.userService.logOutEventHit();
          location.href = '/login';
        }
      });

    //   }
    // });
    this.idSelectCheckBox = '';
  }

  changeCurrency(currency) {
    if (currency) {
      this.currencies = [];
      $('.pkj-currency').hide();
      this.userService
        .updateCurrency(
          {
            preferredCurrency: currency.shortName,
          },
          this.userData.token
        )
        .toPromise().then((m: any) => {
          if (m.status === 200) {
            $('#searchcurrency1').val(
              currency[
              'fullName' +
              (this.currentLang == 'en'
                ? ''
                : this.currentLang.toUpperCase())
              ]
            );
            $('#searchcurrency2').val(
              currency[
              'fullName' +
              (this.currentLang == 'en'
                ? ''
                : this.currentLang.toUpperCase())
              ]
            );
            this.resizeAmount();
            this.userData = this.userService.getLoggedData();
            this.userData.preferredCurrency = currency;
            this.usdDollar = currency;
            this.allCurrencies = this.allCurrencies1.filter(
              (currency) =>
                currency.shortName !== this.userData.preferredCurrency.shortName
            );
            this.userService.setUserData(this.userData);
            this.userService.changeUserData();
            this.message = m.message;
            this.searchcurrency1 = '';
            const current = this.allCurrencies.filter((c) => {
              return c.shortName === currency.shortName;
            });
            this.currentCurrency = current[0];
          } else {
            this.message = m.message;
            $('#time_out').modal('show');
          }
        });
    }
  }

  resizeAmount() {
    const maxW = 145,
      maxH = 35,
      maxSize = 14;
    const c = document.getElementsByClassName(
      'fitCurrency'
    ) as HTMLCollectionOf<HTMLElement>;
    const d = document.createElement('input');
    d.style.fontSize = maxSize + 'px';
    for (let i = 0; i < c.length; i++) {
      d.innerHTML = c[i].innerHTML;
      document.body.appendChild(d);
      const w = d.offsetWidth;
      const h = d.offsetHeight;
      document.body.removeChild(d);
      const x = w > maxW ? maxW / w : 1;
      const y = h > maxH ? maxH / h : 1;
      const r = Math.min(x, y) * maxSize;
      c[i].style.fontSize = r + 'px';
    }
  }

  getProfile() {
    this.userService
      .getProfileData(this.userData.token)
      .pipe(takeUntil(this.unsubscribe$))
      .toPromise().then((m: any) => {
        if (m.status === 200) {
          this.userData = this.userService.getLoggedData();
          this.profileData = m.data;
          this.userData.verificationStatus =
            this.profileData.verificationStatus;
          this.userData.verificationStatusString =
            this.profileData.verificationStatusString;
          this.userService.changeVerificationStatusString(
            this.profileData.verificationStatusString,
            false
          );
          this.userData.preferredLanguage = this.profileData.preferredLanguage;
          this.userData.antiPhishingStatus =
            this.profileData.antiPhishingStatus;
          this.userData.antiPhishingCode = this.profileData.antiPhishingCode;
          this.userData.ipManagement = this.profileData.ipManagement;
          this.userService.setUserData(this.userData);

          this.setVerificationStatusString();
          let urlLang = null;
          this.activeRoute.queryParams
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((a) => {
              if (a.language) {
                urlLang = a.language;
              }
            });
          this.translate.setDefaultLang(
            (
              urlLang ||
              this.profileData.preferredLanguage ||
              'en'
            ).toLocaleLowerCase()
          );
          this.userService.changeLanguageEmit(
            (
              urlLang ||
              this.profileData.preferredLanguage ||
              'en'
            ).toLowerCase(),
            false
          );
        } else {
          this.translate
            .get('error')
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((er: any) => {
              const msg = m.message;
              const err = er;
              this.message = msg;
              this.toast.error(msg, err, {
                timeOut: 15000,
              });
            });
        }
      });
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    if (this.stompClient && this.stompClient.connected) {
      this.stompClient.disconnect(() => {
        if (!environment.production) {
          console.log('disconnect trade window');
        }
      });
    }

    // Subscribe to Resize Screen Event
    $(window).resize(() => {
      if (window.innerWidth > 991) {
        $('.sidebar').css({ left: '0px', width: '185px' });
      } else {
        this.menuActive = false;
        $('.sidebar').css('left', '-250px');
      }
    });

    // Subscribe to Route Change
    this.router.events.pipe(takeUntil(this.unsubscribe$)).subscribe((event) => {
      if (event.constructor.name === 'NavigationStart') {
        this.menuActive = false;
      }
    });
    window.addEventListener('focus', () => {
      const tokenData = this.userService.getToken();
      if (!tokenData.token) {
        const urls = [
          '/',
          'market',
          'buy-sell-market',
          'about-us',
          'fee',
          'privacy-policy',
          'term-and-condition',
          'subscribe',
          'subscribe',
          'login',
          'forgot-password',
          'reset-password',
          'info',
          'confirmation',
          'verify-email',
          'verify-account',
          'change-phone',
          'check-sms-phone',
          'simple-exchange-public',
          'quick-exchange-public',
          'advance-exchange',
          // "start-verification",
          // "verification-guide",
          'verification-error',
          'welcome',
          'verify',
          // "price-equation",
          // "profit-calculation",
          // "reputation-calculation"
        ];
        let redirect = true;
        for (let i = 0; i < urls.length; i++) {
          if (
            CustomUrlSerializer.decript(this.router.url).indexOf(
              '/' + urls[i]
            ) != -1 ||
            CustomUrlSerializer.decript(this.router.url) == urls[i]
          ) {
            redirect = false;
          }
        }
        if (redirect) {
          this.cookieService.deleteAll('/', location.hostname);
          this.userService.deleteUserData();
          this.userService.deleteToken();
          this.userService.isLoggedIn = false;
          this.messagingService.changeVerificationStatus();

          localStorage.clear();

          if (!environment.production) {
            console.log('HEADER 631: HIT LOG OUT EVENT');
          }
          this.userService.logOutEventHit();
          this.route.navigate(['/login']);
        }
      }
    });
    this.idSelectCheckBox = '';
  }

  userProfileBox(event) {
    $('.drop_down_hd').slideToggle();
    event.stopPropagation();
  }

  notificationBox(event) {
    $('.bell_ic .drop_downN3').slideToggle();
    event.stopPropagation();
    this.isClicked = false;
    this.selectAllNotification = false;
    this.activeDeleteOption = false;
    this.arrNotification = [];
    this.numberOfChecked = 0;
    $('input:checkbox').prop('checked', false);
    for (let i = 0; i < this.notifiations.length; i++) {
      $('.notificationDiv ul li:nth-child(' + (i + 1) + ')')
        .css('background', 'transparent')
        .hover(function (e) {
          $(this).css(
            'background-color',
            e.type === 'mouseenter' ? 'rgba(32, 202, 254, 0.1)' : 'transparent'
          );
        });
    }
  }

  changeLanguageLocal(lang) {
    this.cookieService.set(
      'OBSIDIAM-LOCALE',
      lang.lang,
      new Date(new Date().getTime() + environment.cookieExpireTime),
      '/',
      window.location.hostname,
      true,
      'Strict'
    );
    GlobalConstants.language = lang.lang;
    this.currentLang = lang.lang;
    this.updateLanguage(lang.lang);
    this.userService.changeVerificationStatusLanguage();
    this.language = { lang: lang.lang, text: lang.text };
    $('#searchcurrency1').val(
      this.userData.preferredCurrency[
      'fullName' +
      (this.currentLang === 'en' ? '' : this.currentLang.toUpperCase())
      ]
    );
    $('#searchcurrency2').val(
      this.userData.preferredCurrency[
      'fullName' +
      (this.currentLang === 'en' ? '' : this.currentLang.toUpperCase())
      ]
    );
    this.languages = [];
  }

  async updateLanguage(lang: string) {
    const data = {
      language: lang,
    };
    this.userService
      .updateLanguage(data, this.userData.token)
      .pipe(takeUntil(this.unsubscribe$))
      .toPromise().then((m: any) => {
        if (m.status === 200) {
          zendeskChangeLanguage(lang);
          this.translate.setDefaultLang(lang.toLocaleLowerCase());
          this.setVerificationStatusString();
          this.changeSideBarTooltipLanguage.emitChangeLang();

          //hit api's after changing language
          this.hipApiAfterLanguageChange();
          // Language changed
          GlobalConstants.languageChangeFunctionCallInHeader = true;
          this.userData.preferredLanguage = lang;
          this.userService.setUserData(this.userData);
          this.userService.changeLanguageEmit(lang, false);
          this.translate
            .get('success')
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((title: any) => {
              this.message = m.message;
              this.userData.preferredLanguage = lang;
              this.userService.setUserData(this.userData);
              this.userService.changeLanguageEmit(lang, false);
              this.toast.success(m.message, title, {
                timeOut: 6000,
              });
              this.obsicashStore.changeLng(lang);
            });
        } else {
          this.message = m.message;
          this.toast.error(m.message, 'Error!', {
            timeOut: 6000,
          });
        }
      });
  }

  hipApiAfterLanguageChange() {
    setTimeout(() => {
      this.getUnradNotifications();
      if (
        CustomUrlSerializer.decript(this.router.url).indexOf('dashboard') != -1
      ) {
        this.langService.hitApiOnDashboardOnLanguageChange();
      } else if (
        CustomUrlSerializer.decript(this.router.url).indexOf('notifications') !=
        -1
      ) {
        this.langService.hitApiOnNotificationPageOnLanguageChange();
      } else if (
        CustomUrlSerializer.decript(this.router.url).indexOf('wallet') != -1
      ) {
        this.langService.hitApiOnWalletOnLanguageChange();
      } else if (
        CustomUrlSerializer.decript(this.router.url).indexOf('transaction') !=
        -1
      ) {
        this.langService.hitApiOnWalletOnLanguageChange();
      }
    }, 1000);

    // console.log('CustomUrlSerializer.decript(this.router.url)', CustomUrlSerializer.decript(this.router.url))
  }

  setLanguage() {
    if (!environment.production) {
      // console.log('header', this.userData.preferredLanguage || 'en');
    }
    this.translate.setDefaultLang(
      (this.userData.preferredLanguage || 'en').toLowerCase()
    );
    this.translate.use((this.userData.preferredLanguage || 'en').toLowerCase());
    if (this.userData.preferredLanguage === 'en') {
      this.language = { lang: 'en', text: 'English' };
    } else if (this.userData.preferredLanguage === 'es') {
      this.language = { lang: 'es', text: 'Español' };
    } else if (this.userData.preferredLanguage === 'pt') {
      this.language = { lang: 'pt', text: 'Português' };
    }
    this.setVerificationStatusString();
  }

  menuEvent() {
    this.menuActive = !this.menuActive;
    if (this.menuActive) {
      $('.sidebar').css({ left: '0px', width: '185px' });
    } else {
      $('.sidebar').css('left', '-250px');
    }
  }

  showTourOptions() {
    this.tourActiveService.endTour();
    $('#tour-popup').modal('show');
  }

  tourSelected(sectionSelected: string) {
    $('#tour-popup').modal('hide');
    this.showTour = !this.showTour;
    this.tourActiveService.activateTour(sectionSelected, false, false);
  }

  getVerificationStatus() {
    this.userService
      .getVerificationStatus(this.userData.userId, this.userData.token)
      .pipe(takeUntil(this.unsubscribe$))
      .toPromise().then((m: any) => {
        if (m) {
          if (m.status === 4033 || m.status === 4034) {
            this.userService.changeVerificationStatusString('FAILED', true);
            this.userData.verificationStatus = false;
            // fbq("track", "CompleteRegistration");
            ga('send', 'event', 'User Path', 'User Verification', 'fallida');
          }
          if (m.status === 4032) {
            this.userData.verificationStatus = false;
            this.userService.changeVerificationStatusString('SUBMITTED', true);
          }
          if (m.status === 4031) {
            this.userService
              .getProfileData(this.userData.token)
              .pipe(takeUntil(this.unsubscribe$))
              .toPromise().then((m2: any) => {
                if (m2 && m2.status === 200) {
                  if (
                    m2.data.verificationStatusString !== 'SUBMITTED' &&
                    m2.data.verificationStatusString !== 'SUCCESS'
                  ) {
                    this.userService.changeVerificationStatusString(
                      'PENDING',
                      true
                    );
                    this.userData.verificationStatus = false;
                  }
                  if (m2.data.verificationStatusString === 'SUCCESS') {
                    this.userData.verificationStatus = true;
                    // fbq("track", "CompleteRegistration");
                    ga(
                      'send',
                      'event',
                      'User Path',
                      'User Verification',
                      'aprobada'
                    );
                  }
                }
              });
          }
          if (m.status === 200) {
            this.userData.verificationStatus = true;
            this.userService.changeVerificationStatusString('SUCCESS', true);
          }
          this.setVerificationStatusString();
          this.userService.changeUserData();
        }
      });
  }

  setVerificationStatusString() {
    if (this.userData.verificationStatus) {
      this.translate
        .get('verification_status.verified')
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((er: any) => {
          this.verificationStatusEnum = er;
        });
    } else {
      this.userData.verificationStatus = this.userData.verificationStatus;
      this.userData.verificationStatusString =
        this.userData.verificationStatusString;
      switch (this.userData.verificationStatusString) {
        case 'PENDING':
          this.translate
            .get('verification_status.unverified')
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((er: any) => {
              this.verificationStatusEnum = er;
            });
          break;
        case 'SUBMITTED':
          this.translate
            .get('verification_status.pending')
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((er: any) => {
              this.verificationStatusEnum = er;
            });
          break;
        case 'SUCCESS':
          this.translate
            .get('verification_status.verified')
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((er: any) => {
              this.verificationStatusEnum = er;
            });
          break;
        case 'FAILED':
          this.translate
            .get('verification_status.failed')
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((er: any) => {
              this.verificationStatusEnum = er;
            });
          break;
        case 'ONBOARDING_PENDING':
          this.translate
            .get('verification_status.pending')
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((er: any) => {
              this.verificationStatusEnum = er;
            });
          break;
        case 'ONBOARDING_COMPLETED':
          this.translate
            .get('verification_status.inprocess')
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((er: any) => {
              this.verificationStatusEnum = er;
            });
          break;
      }
    }
    console.log(this.verificationStatusEnum)
  }

  routerBox(route: string) {
    this.router.navigate([route]);
  }

  searchLanguages($event: MouseEvent) {
    if (!this.languages.length) {
      this.translate
        .get('header.languages')
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((langs: any) => {
          this.languages = langs;
        });
    } else {
      this.languages = [];
    }
  }

  dropDownsControl() {
    $(document).on('click', (e) => {
      if (e && e.target && e.target.id) {
        setTimeout(() => {
          if (
            $(e.target).attr('id') !== 'searchcurrency1' &&
            $(e.target).attr('id') !== 'searchcurrencyImg1' &&
            $(e.target).attr('id') !== 'searchcurrency2' &&
            $(e.target).attr('id') !== 'searchcurrencyImg2' &&
            this.currencies &&
            this.currencies.length
          ) {
            this.currencies = [];
          }

          if (
            $(e.target).attr('id') !== 'searchlanguage1' &&
            $(e.target).attr('id') !== 'searchlanguageImg1' &&
            $(e.target).attr('id') !== 'searchlanguage2' &&
            $(e.target).attr('id') !== 'searchlanguageImg2' &&
            this.languages &&
            this.languages.length
          ) {
            this.languages = [];
          }
          if (
            (this.idSelectCheckBox !== '' &&
              $(e.target).attr('id') !== this.idSelectCheckBox &&
              $(e.target).attr('id') !== 'formCheckBox') ||
            $(e.target).attr('id') === undefined
          ) {
            $('.drop_downN3').slideUp();
          }
        }, 0);
      }
    });
  }

  acceptCookies() {
    this.cookieService.set(
      'OBSIDIAM-COOKIES',
      JSON.stringify(false),
      new Date(new Date().getTime() + environment.cookieExpireTime),
      '/',
      window.location.hostname,
      true,
      'Strict'
    );
    localStorage.setItem('cookies', JSON.stringify(false));
    this.showCookies = false;
  }

  privacyPolicy() {
    this.router.navigate(['/logged/privacy-policy']);
  }

  showCalculator() {
    GlobalConstants.calculatorFocus = false;
    this.calculatorServices.toggle();
  }

  routerToVerification() {
    this.userService.showVerifyUserToast.next('hide');
    if (this.userData.userType === 'BUSINESS') {
      this.route.navigate(['/verification-guide/business']);
    } else {
      this.route.navigate(['/profile/verification']);
    }
  }

}
